import React from "react";

function BusinessPage() {
  const containerStyle = {
    maxWidth: "800px",
    margin: "0 auto",
    padding: "2rem"
  };

  const headingStyle = {
    marginBottom: "1rem"
  };

  const subheadingStyle = {
    marginTop: "1.5rem",
    marginBottom: "0.75rem"
  };

  return (
    <div style={containerStyle}>
      <h1 style={headingStyle}>Offres Baltee Mobility pour les Entreprises</h1>

      <p>
        <strong>Baltee Mobility</strong> accompagne les entreprises souhaitant intégrer
        des solutions de mobilité durables et innovantes dans leur quotidien. Qu’il s’agisse
        de déplacements professionnels, de livraisons urbaines ou d’offres de mobilité
        pour les employés, nous proposons des formules modulables et adaptées à chaque besoin.
      </p>

      <h2 style={subheadingStyle}>Pourquoi choisir Baltee Mobility&nbsp;?</h2>
      <ul>
        <li>
          <strong>Fleet Management Simplifié</strong> : Gérez l’ensemble de votre flotte 
          de B01 et grâce à notre tableau de bord dédié. Surveillez en temps
          réel l’autonomie, la localisation et l’état des appareils.
        </li>
        <li>
          <strong>Offres sur mesure</strong> : Nous proposons un large éventail de formules
          (locations flexibles, contrats de longue durée, maintenance incluse etc.)
          afin de répondre à vos exigences spécifiques.
        </li>
        <li>
          <strong>Expertise Technique</strong> : Notre équipe d’ingénieurs et de techniciens
          est à votre disposition pour assurer l’installation, la formation des
          utilisateurs et la maintenance de vos dispositifs Baltee.
        </li>
        <li>
          <strong>Réduction de l’empreinte carbone</strong> : Grâce à nos solutions de
          micro-mobilité électriques ou hybrides, vous agissez en faveur de la préservation
          de l’environnement tout en optimisant vos coûts de transport.
        </li>
      </ul>

      <h2 style={subheadingStyle}>Nos solutions pour les professionnels</h2>
      <p>
        <strong>Location longue durée (LLD)</strong> : Idéale pour les entreprises
        désireuses de bénéficier de nos appareils sans contrainte d’investissement initial.
        La maintenance est assurée par nos équipes et nous veillons à ce que chaque
        B01 ou reste opérationnel à 100 %.
      </p>
      <p>
        <strong>Formules de courte durée</strong> : Vous organisez un événement, un salon
        ou une opération ponctuelle ? Nous offrons des solutions de location à la semaine
        ou au mois pour vous permettre de tester la flotte Baltee sans engagement prolongé.
      </p>
      <p>
        <strong>Formation et accompagnement</strong> : Sécurité, règles de circulation,
        entretien de base… Nous pouvons former vos collaborateurs pour qu’ils utilisent
        efficacement nos produits et tirent pleinement parti de leurs fonctionnalités
        (géolocalisation, verrouillage à distance etc.).
      </p>

      <h2 style={subheadingStyle}>Service Après-Vente & Assistance</h2>
      <p>
        Nous savons que la réactivité est essentielle pour un usage professionnel.
        C’est pourquoi notre <strong>SAV</strong> dédié aux entreprises met tout en œuvre
        pour résoudre rapidement les dysfonctionnements et minimiser les interruptions 
        de service. Nous proposons des canaux prioritaires (hotline professionnelle, 
        chat dédié) et un accompagnement personnalisé.
      </p>

      <h2 style={subheadingStyle}>Demandez votre devis sur mesure</h2>
      <p>
        Chaque structure étant unique, nous vous invitons à contacter notre service
        commercial pour établir un devis personnalisé. Nous étudierons ensemble
        votre projet (taille de la flotte, modalités de livraison, exigences spécifiques)
        afin de définir l’offre la mieux adaptée.
      </p>
      <p>
        Pour cela, vous pouvez remplir notre <strong>formulaire de contact</strong> 
        disponible dans la section <em>Contact & SAV</em> ou nous joindre directement 
        à l’adresse e-mail <a href="mailto:contact@baltee.com">contact@baltee.com</a>.
      </p>

      <h2 style={subheadingStyle}>Ils nous font déjà confiance</h2>
      <p>
        De nombreuses entreprises (start-ups, PME, collectivités, grands groupes)
        ont choisi Baltee Mobility pour simplifier leurs déplacements urbains ou proposer
        un service de transport partagé à leurs collaborateurs. Rejoignez-les et
        faites de la mobilité durable un véritable atout pour votre organisation !
      </p>
    </div>
  );
}

export default BusinessPage;
